import React, { ReactElement } from 'react';
import Link, { LinkProps } from 'next/link';

type TabLinkProps = LinkProps & {
  children: ReactElement;
  // pass a value to ensure that MUI applies our styles to our Link
  value: string;
};

export const TabLink = ({ children, value, ...rest }: TabLinkProps): ReactElement => {
  // Clone the child element and pass it the Link props so MUI can apply styles
  const childWithProps = React.cloneElement(children, { value });

  return <Link {...rest}>{childWithProps}</Link>;
};
